export const TOPIC_GRAPH_COMMENT_TYPE = 'comment';

export type TopicGraphOutputKey = `opt-${number}`;

export interface TopicGraphNodeData {
  questionIndex: number;
  questionText: string;
  isRequired: boolean;
  metrics: string[];
  isQuestionTrigger: boolean;
  choices: Record<string, string>;
  statements?: (string | undefined)[];
  type: string;
  range?: { min: number; max: number };
  input: boolean;
  outputs: Record<string, number | null>;
  position?: (number | null)[];
  reportOrder: number | null;
  commentGroupId?: string;
}

export type TopicGraphValidationErrorPart =
  | 'questionText'
  | 'input'
  | 'reportOrder'
  | 'min'
  | 'max'
  | 'min/max'
  | `choice-opt-${number}`
  | `output-opt-${number}`
  | `statement-${number}`;

export type TopicGraphValidationErrorCode =
  | 'validationNoConnection'
  | 'validationEmpty'
  | 'validationMinLesserThan1'
  | 'validationMinLesserThan0'
  | 'validationMaxLesserThan2'
  | 'validationMaxLesserThan1'
  | 'validationMaxLesserThanMin'
  | 'validationMaxGreaterThanOptions'
  | 'validationReportOrderUnique'
  | 'validationMissingStartNode'
  | 'validationMultipleStartNodes'
  | 'validationMissingEndingNode'
  | 'validationMultipleEndingNodes'
  | 'validationEndingMustHaveInput'
  | 'validationEndingMustHaveNoOutputs'
  | 'validationUnreachableFromStart';

export interface TopicGraphValidationError {
  questionIndex: number;
  part: TopicGraphValidationErrorPart | string;
  error: TopicGraphValidationErrorCode;
}
